import _extends from "@babel/runtime/helpers/extends";
import React from 'react'; // eslint-disable-next-line import/no-duplicates

import { SignArea, FormItem } from '@/baseComponents';
import './index.less';
export default function HolderSign(props) {
  const {
    formKey,
    label,
    rules = [{
      required: true,
      message: '请输入'
    }],
    remark = {}
  } = props;
  const formItemProps = {
    label: null,
    remark,
    name: 'agent.signImageUrl',
    fieldOption: {
      rules
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "SignContent"
  }, /*#__PURE__*/React.createElement("div", null, "\u5728\u7EBF\u7B7E\u540D"), /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps, {
    noStyle: true
  }), /*#__PURE__*/React.createElement(SignArea, null))));
}